/**
 * Feature Config Cache Configuration
 * 
 * Customize how feature configurations are cached in the frontend
 */

const FeatureConfigCacheConfig = {
  /**
   * Enable/Disable caching
   * Set to false to always fetch fresh data from API (useful for debugging)
   * BẬT để login khỏi đợi /check-my-features mỗi lần — cache 30 phút đủ cho 1 ca làm việc.
   */
  enabled: true,

  /**
   * Cache timeout in milliseconds
   * 30 phút — features ít thay đổi trong 1 ca làm việc của đại lý.
   */
  timeout: 30 * 60 * 1000,

  /**
   * Cache storage type
   * Options:
   * - 'localStorage': Persists across browser sessions, survives page refresh
   * - 'sessionStorage': Persists only during browser session, cleared when tab closes
   * - 'memory': In-memory only, cleared on page refresh (fastest but least persistent)
   */
  storageType: 'localStorage',

  /**
   * Cache key prefix
   * Useful if you have multiple apps on same domain
   */
  keyPrefix: 'mlm_feature_config_',

  /**
   * Auto-refresh on window focus
   * If true, will check and refresh expired cache when user returns to tab
   */
  refreshOnFocus: false,

  /**
   * Background refresh before expiry
   * If true, will refresh cache in background when 80% of timeout has passed
   * User sees old data while new data loads in background
   */
  backgroundRefresh: false,

  /**
   * Retry strategy for failed API calls
   */
  retry: {
    enabled: true,
    maxAttempts: 2,
    delayMs: 1000, // Wait 1 second between retries
  },

  /**
   * Fallback behavior when API fails
   */
  fallback: {
    /**
     * Use expired cache if API fails
     * If true, will use cached data even if expired when API call fails
     */
    useExpiredCacheOnError: true,

    /**
     * Default features if no cache and API fails
     * Can return empty array or a default feature set
     */
    defaultFeatures: [],
  },

  /**
   * Debug logging
   * Set to true to see detailed cache operations in console
   */
  debug: false,
};

export default FeatureConfigCacheConfig;
